export default __webpack_public_path__ + "f00f898780ba7f9b1b0ba24685d17a8d.png";